if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
       this.querySelectorAll('[data-index^="option"]').forEach(select => {
          select.addEventListener('change', () => {
            setTimeout(() => this.updatePriceBySelectedOptions(), 400);
          });
        });

        const selectElementSticky = document.querySelector(".sticky-atc-bar__variant-select");

        if (selectElementSticky) {
          selectElementSticky.addEventListener("change", () => {
            setTimeout(() => this.updatePriceBySelectedOptions(), 500);
          });
        }
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }

        // this.updatePriceBySelectedOptions();
        setTimeout(() => this.updatePriceBySelectedOptions(), 400);
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );

            if (!variant) {
              this.setUnavailable();
              return;
            }
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
          console.log("this.currentVariant",this.currentVariant)
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          this.querySelectorAll('[data-index^="option"]').forEach(select => {
            select.addEventListener('change', () => {
              setTimeout(() => this.updatePriceBySelectedOptions(), 400);
            });
          });

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku');
          updateSourceFromDestination('Inventory');
          updateSourceFromDestination('Badges');
          updateSourceFromDestination('PricePerItem');
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination('QuantityRules');
          updateSourceFromDestination('VolumeNote');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);
          if (stickyAtcBar) {
            stickyAtcBar.classList.remove('hidden');
          }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: variant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const newVariantSelects = html.querySelector('variant-selects');
        const currentVariantSelects = this.variantSelectors;

        if (!newVariantSelects || !currentVariantSelects) return;

        const currentProductUrl = currentVariantSelects.dataset.url;
        const newProductUrl = newVariantSelects.dataset.url;
        
        if (currentProductUrl !== newProductUrl) {
          HTMLUpdateUtility.viewTransition(
            currentVariantSelects,
            newVariantSelects,
            this.preProcessHtmlCallbacks
          );
        } else {
           const newFieldsets = newVariantSelects.querySelectorAll('fieldset');
            const currentFieldsets = currentVariantSelects.querySelectorAll('fieldset');
            newFieldsets.forEach((newFieldset, index) => {
            const newLegend = newFieldset.querySelector('legend');
            const currentLegend = currentFieldsets[index]?.querySelector('legend');
            if (newLegend && currentLegend) {
              const newHTML = newLegend.outerHTML.trim();
              const currentHTML = currentLegend.outerHTML.trim();
              if (newHTML !== currentHTML) {
                currentLegend.replaceWith(newLegend.cloneNode(true));
              }
            }
          });
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = this.decoded(text);
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.decoded(FoxTheme.variantStrings.addToCart);
        }

        if (!modifyClass) return;
      }

      decoded(text) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        const decoded = tempDiv.textContent;
        return decoded;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const volumePricing = document.getElementById(`Volume-${this.dataset.section}`);
        const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (volumePricing) volumePricing.classList.add('hidden');
        if (stickyAtcBar) stickyAtcBar.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }

      updatePriceBySelectedOptions() {
        const productHandle = this.dataset.productHandle;
        fetch(`/products/${productHandle}.js`)
          .then(res => res.json())
          .then(productData => {
            const selectedOptions = [];
            const optionFields = this.querySelectorAll('[data-index^="option"]');
            let lastCheckedInput = null;

            optionFields.forEach(field => {
              const checkedInput = field.querySelector('input[type="radio"]:checked, input[type="hidden"]');
              if (checkedInput) {
                selectedOptions.push(checkedInput.value);
                lastCheckedInput = checkedInput;
              }
            });

            // setTimeout(() => {
            //   const quantity = lastCheckedInput?.dataset.quantity;
            //   if (quantity) {
            //     const quantityInput = document.querySelector('.quantity__input');
            //     if (quantityInput) quantityInput.value = quantity;
            //   }
            // }, 100);

            if (selectedOptions.length === 0) return;

            const matchingVariants = productData.variants.filter(variant =>
              variant.option1 === selectedOptions[0]
            );

            const moneyFormat = FoxTheme.settings.moneyFormat || '{{amount_no_decimals_with_comma_separator}} €';

            const priceElements = this.querySelectorAll('.variant-price');
            const comparePriceElements = this.querySelectorAll('.variant-price--regular');
            const unitPriceElements = this.querySelectorAll('.variant-price-unit');
            const comparePriceSaleElements = this.querySelectorAll('.variant-price-sale');

            matchingVariants.forEach((variant, index) => {
              const price = variant.price;
              const comparePrice = variant.compare_at_price;
              const savingAmount = comparePrice - price;

              const formattedPrice = this.formatMoney(price, moneyFormat);
              const formattedComparePrice = this.formatMoney(comparePrice, moneyFormat);
              const formattedSaving = this.formatMoney(savingAmount, moneyFormat);
              
              const priceCompareNumber = parseFloat(formattedComparePrice.replace(/[^\d.]/g, ''));

              const metafieldsJson = document.getElementById('variant-metafields-json');
              let packQuantity = null;

              if (metafieldsJson) {
                const metafields = JSON.parse(metafieldsJson.textContent);
                packQuantity = metafields[variant.id]?.pack_quantity || null;
              }

              let formattedUnitPrice = '';
              if (packQuantity && price) {
                const unitPrice = price / 100 / Number(packQuantity);
                
                formattedUnitPrice = this.formatMoney(unitPrice * 100, moneyFormat)
              }

              setTimeout(() => {
                const priceElement = priceElements[index];
                const comparePriceElement = comparePriceElements[index];
                const comparePriceSaleElement = comparePriceSaleElements[index];
                const unitPriceElement = unitPriceElements[index];

                if (priceElement) priceElement.textContent = formattedPrice;
                if (comparePriceElement) {
                  if (priceCompareNumber > 0) {
                    comparePriceElement.textContent = formattedComparePrice;
                  } else {
                    comparePriceElement.textContent = '';
                  }
                }
                if (unitPriceElement && packQuantity) unitPriceElement.textContent = formattedUnitPrice;
                if (comparePriceSaleElement) {
                    const rocketPriceSale = comparePriceSaleElement.closest('.rocket-price-sale');
                  if (savingAmount > 0) {
                    comparePriceSaleElement.textContent = formattedSaving;
                    if (rocketPriceSale) rocketPriceSale.style.display = 'block';
                  } else {
                    comparePriceSaleElement.textContent = '';
                    if (rocketPriceSale) rocketPriceSale.style.display = 'none';
                  }
                }

                optionFields.forEach((field, optionIndex) => {
                  const variantOption = variant[`option${optionIndex + 1}`];
                  const labels = field.querySelectorAll('label');

                  labels.forEach(label => {
                    const inputId = label.getAttribute('for');
                    const input = document.getElementById(inputId);

                    if (input && input.value === variantOption) {
                      if (packQuantity) {
                        label.classList.add('pack-variant');
                        input.dataset.quantity = packQuantity;
                        label.classList.remove('no-pack-variant');
                      } else {
                        label.classList.remove('pack-variant');
                        label.classList.add('no-pack-variant');
                        delete input.dataset.quantity;
                      }
                    }
                  });
                });
              }, 0);
            });
          })
          .catch(console.error);
      }
      
      formatMoney(value, moneyFormat) {
        const amount = (value / 100).toFixed(2);
        const noDecimals = (value / 100).toFixed(0);
        const commaSeparated = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return moneyFormat
          .replace('{{amount}}', amount)
          .replace('{{amount_no_decimals}}', noDecimals)
          .replace('{{amount_no_decimals_with_comma_separator}}', commaSeparated);
      }

    }
  );
}
if (!customElements.get('rocket-pack-inventory')) {
  customElements.define(
    'rocket-pack-inventory',
    class RocketPackInventory extends HTMLElement {
      constructor() {
        super();
        const inputs = this.querySelectorAll('input[name="cantidad-variant-custom"]');
        inputs.forEach(input => {
          input.addEventListener('change', (event) => {
            if (event.target.checked) {
              const selected = event.target;

              const value = selected.value;
              const label = this.querySelector('[data-selected-swatch-value-custom="Cantidad"]');
              if (label) label.textContent = value;
            }
          });
        });
      }
    }
  );
}
